import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const QuizzesPage = () => {
  return <TitledPage title={t("Admin Quizzes")}></TitledPage>;
};

export default QuizzesPage;
